import type { LearnTopic } from '../types';

export const rollTopic: LearnTopic = {
  id: 'roll',
  tier: 'position',
  title: 'What a roll does',
  summary: 'Close a side and reopen it further out or further away, usually one side at a time.',
  body: [
    'Rolling means closing a spread and opening a replacement, usually at a later expiration, sometimes at different strikes. You do it to buy time or to move a threatened short strike away from the price.',
    'On an iron condor you roll one side at a time, because only one side is ever in trouble. The untouched side keeps its original legs and expiration; the rolled side gets new ones. Steward keeps both under the same chain, so the iron condor stays one trade with a history.',
    'A roll has its own net: the credit for the new spread minus the cost of closing the old one. A roll for a net credit adds to what the trade can make; a roll for a debit spends some of the original credit to reduce risk. Either way the max loss is recomputed from the new strikes.',
  ],
  explain(ctx) {
    const { shortPut, longPut, shortCall, longCall, dte } = ctx;
    const bothSides = shortPut != null && shortCall != null;
    return [
      'This chain has been rolled; the current legs are what the roll left in place.',
      bothSides
        ? `Right now the put side is at ${shortPut}/${longPut ?? 'no wing'} and the call side at ${shortCall}/${longCall ?? 'no wing'}${dte != null ? `, with ${dte} days to the nearest expiration` : ''}.`
        : 'Only one side is open at the moment, which is the usual shape midway through rolling one side.',
      "When you roll one side, the other side's strikes and expiration do not change.",
    ];
  },
  appliesTo(_ctx, chain) {
    return chain.rollCount > 0;
  },
};
